import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useTranslation } from 'react-i18next';
import { CloseButton } from '../closeButtonComponent';
import { RecoveryBackupCardButton } from './recoveryBackupcardButton';
import { SaveBackupCardButton } from './saveBackupCardButtonComponent';

import {Center,Box,Button,Text,useDisclosure,Image} from '@chakra-ui/react';
import { CloseButtonChakra } from "../closeButtonChakraComponent";

type Props = {
    setHiddenSaveBackupCardStatus:any,
    setQRTagStatus:any,
    videoRef:React.MutableRefObject<HTMLVideoElement>,
    canvasRef:React.MutableRefObject<HTMLCanvasElement>,
    onClickFlagStatu:boolean,
    setOnClickFlagStatus:any,

    // closebuttonStyle: React.CSSProperties;
}
export const ExplanationBackupcard: React.FC<Props> = (props) => {

  const [backupAddressFlag,setbackupAddressFlag] = React.useState(true);
  const [backupAddressTextStatus,setBackupAddressTextStatus] = React.useState(`ご利用のブラウザにNFTが保存されています`);
  const [t, i18n] = useTranslation();

  const ExplanationBackupcardDiv = styled.div`
    justify-content: center;
    display: inline-block;

    border-radius: 20px;
    margin-top: 30px;
    width: 80%;
    margin-left: 1%;
    background: linear-gradient(339.68deg, rgba(239, 239, 239, 0.6) 4.62%, rgba(255, 255, 255, 0.45) 93.97%);
    padding-bottom: 20px;
    border: 1px solid rgba(239, 239, 239, 0.2);
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(10px);
`;
  const ExplanationBackupcardHead = styled.p`
     padding-top: 20px;
     font-weight: 700;
     margin-top: 0;
     color:black;
  `;
  const BackupcardsampleImage = styled.img`
    width: 30%;
    border-style: solid;
    vertical-align: middle;
    border-color: black;
    display: unset;
  `;
  const BackupcardExplainText = styled.p`
    font-weight: bold;
    margin-top: 10px;
    font-size: 12px;
    color:black;
  `;  
  const BackupcardStatusText = styled.p`
    color: #FF7000;
    font-weight: 700;
    margin-top: 0;
  `;
  const BackupcardStatusMessage = styled.p`
    font-weight: bold;
    font-size: 12px;
    margin-top: 0;
    color:black;
  `;  
  const hrStyle:React.CSSProperties={
    height: '1px',
    width: '90%',
    marginLeft: '5%',
    color: 'black',
  }
  React.useEffect(()=>{
    if (localStorage.getItem('walletAddressFromPK')) {
      setbackupAddressFlag(true);
      setBackupAddressTextStatus(`ご利用のブラウザにNFTが保存されています`);
    } else {
      setbackupAddressFlag(false);
      setBackupAddressTextStatus(`NFTはブラウザに保存されていません`);
    }
  },[]);
  return (
    <ExplanationBackupcardDiv>
        {/* <CloseButton closebuttonStyle={props.closebuttonStyle}/> */}
        <Box
          mt={'20px'}
          textAlign={'left'}
          ml={'30px'}
        >
          <CloseButtonChakra/>
        </Box>
        <ExplanationBackupcardHead id="whatisbackupcardhead">{t('NFTバックアップカードとは？')}</ExplanationBackupcardHead>
        <BackupcardsampleImage id="backupcardsample" src="https://nfttopshot-template.onrender.com/template-images/nftbackupcard_sample.jpg"/>
        <BackupcardExplainText>{t('ブラウザに保存されたNFTを復元するのに必要なカードです。MetaMask等の外部ウォレットのみを使用している場合は不要です。')}<br/></BackupcardExplainText>
        <hr style={hrStyle}/>
        <BackupcardStatusText id="backupcardstatus">{t(backupAddressTextStatus)}</BackupcardStatusText>
        <hr style={hrStyle}/>
        {backupAddressFlag === true && <SaveBackupCardButton  setQRTagStatus={props.setQRTagStatus} setHiddenSaveBackupCardStatus={props.setHiddenSaveBackupCardStatus}/>}
        <RecoveryBackupCardButton canvasRef={props.canvasRef} videoRef={props.videoRef} onClickFlagStatus={props.onClickFlagStatu}setOnClickFlagStatus={props.setOnClickFlagStatus}/>
    </ExplanationBackupcardDiv>
  );
};